import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import "./styles.scss";
import { Box } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import "./styles.scss";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";

import { formatDate } from "../../../utils/dateFormat";

type CustomDateRangeProps = {
  handleClose: Function;
  open: boolean;
  handleApplyClose: Function;
  updateDates: Function;
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "363px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CustomDateRange = (props: CustomDateRangeProps) => {
  const { handleClose, open, handleApplyClose, updateDates } = props;
  // Use `null` instead of `undefined` to keep the picker controlled for its lifetime.
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
  const dispatch = useDispatch();

  useEffect(() => {
    if (startDate && endDate && endDate.isBefore(startDate)) {
      setEndDate(startDate);
    }
  }, [startDate, endDate]);

  const clearDates = () => {
    setStartDate(null);
    setEndDate(dayjs());
  };

  useEffect(() => {
    return () => {
      clearDates();
    };
  }, []);

  const handleBackDropClose = (event: any, reason: string) => {
    if (reason && reason === "backdropClick" && "escapeKeyDown") return;
  };

  return (
    <div className="date-range-container">
      <BootstrapDialog
        onClose={handleBackDropClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {"Choose a custom date range"}
        </DialogTitle>
        <div className="dialog-body">
          <Box className="date-picker-container">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={startDate}
                slotProps={{ textField: { size: "small" } }}
                onChange={(newValue) => setStartDate(newValue ?? null)}
              />
            </LocalizationProvider>
          </Box>
          <Box className="date-picker-container">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                value={endDate}
                slotProps={{ textField: { size: "small" } }}
                onChange={(newValue) => setEndDate(newValue ?? dayjs())}
                minDate={startDate ?? undefined}
              />
            </LocalizationProvider>
          </Box>
        </div>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              handleApplyClose();
              clearDates();
            }}
            className="back-to-login-button"
          >
            {"CANCEL"}
          </Button>
          <LoadingButton
            variant="contained"
            data-testid="resetLinkBtn"
            size="small"
            className="send-link-button"
            onClick={() => {
              if (!startDate || !endDate) return;
              dispatch(
                updateDates({
                  startDate: formatDate(startDate.toDate()),
                  endDate: formatDate(endDate.toDate()),
                })
              );
              handleClose();
              clearDates();
            }}
            disabled={!startDate || !endDate}
          >
            {"APPLY"}
          </LoadingButton>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default CustomDateRange;
